(ns frontend.excel-utils
  (:require
   ["number-formatter" :as number-formatter]
   [clojure.string :as string]
   [frontend.utils :as fu]))

(defn excel-date->epoch-ms [excelDate]
  (let [daysIn70years (.round js/Math (+ 25567.5 1))
        daysFrom1900 excelDate
        daysFrom1970 (- daysFrom1900 daysIn70years)
        secondsFrom1970 (* daysFrom1970 3600 24)
        utc (new js/Date (* secondsFrom1970 1000))]
    (if (js/isNaN utc)
      nil
      (.getTime utc))))

(defn format-number
  [n data-format-string]
  ;; TODO - fix this hack by porting excel fortmatter from apache POI to javascript / clojurescript library -> pontentially open source it
  (let [[n data-format-string] (cond (string/includes? data-format-string ",,,")
                                     [(/ n 1000000) (string/replace data-format-string ",,," ",")]
                                     (string/includes? data-format-string ",,")
                                     [(/ n 1000) (string/replace data-format-string ",," ",")]
                                     :else
                                     [n data-format-string])
        data-format-string (if (string/includes? data-format-string ".")
                             data-format-string
                             (str data-format-string "."))
        decimals (if-let [[_ ds] (re-find #"\.(0+)" data-format-string)]
                   (count ds)
                   0)
        n (fu/round n decimals) ;; To avoid issues caused by Javascripts floating point inaccuracies
        formatted (number-formatter data-format-string n)]
    formatted))
;(.format df number "Number" data-format-string))
